import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Label = styled.span`
  font-weight: bold;
  font-size: 1.25em;
  font-style: italic;
  margin: 0 auto;
`;

const ClientLabel = (props) => {
  const {
    label,
  } = props;

  return (
    <Label>{label}</Label>
  );
};

export default ClientLabel;

ClientLabel.propTypes = {
  label: PropTypes.string,
};

ClientLabel.defaultProps = {
  label: '',
};
